<template>
  <j-modal
    :title="title"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules">
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="dayOfWeek" label="每周星期几">
          <j-dict-select-tag style="width: 130px" dict-code="dayOfWeek" v-model="model.dayOfWeek" ></j-dict-select-tag>
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="beginTime" label="可预约辅导开始时间">
          <a-time-picker format="HH:mm:00" v-model="beginTime" @change="changeBeginTime"/>
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="endTime" label="可预约辅导结束时间">
          <a-time-picker format="HH:mm:00" v-model="endTime" @change="changeEndTime"/>
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="num" label="可预约辅导次数" >
          <a-input-number :min="1" v-model="model.num"/>
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="辅导老师" >
          <!-- <a-input v-model="model.name"/> -->
          <a-select
            show-search
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
            v-model="model.psychologistId"
            placeholder="请选择老师"
            @search="handleUserSearch"
            @change="handleUserChange"
            allowClear
          >
            <a-select-option v-for="d in userData" :key="d.id">
              {{ d.realname }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </j-modal>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import Vue from "vue";
  import {TENANT_ID} from "@/store/mutation-types";
  import moment from "moment"

  export default {
    name: "SchoolCounselingConfigModal",
    data () {
      return {
        title:"操作",
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        beginTime: '',
        endTime: '',
        confirmLoading: false,
        validatorRules:{
          beginTime: [
            { required: true, message: '请输入可预约辅导开始时间', trigger: 'change' },
          ],
          endTime: [
            { required: true, message: '请输入可预约辅导结束时间', trigger: 'change' },
          ],
          num: [
            { required: true, message: '请输入可预约辅导次数', trigger: 'blur' },
          ],
          dayOfWeek: [
            { required: true, message: '请输入可预约辅导开始时间', trigger: 'change' },
          ]
        },
        url: {
          add: "/schoolCounselingConfig/add",
          edit: "/schoolCounselingConfig/edit",
        },
        userData: []
      }
    },
    created () {
    },
    methods: {
      add () {
        //初始化默认值
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        if(this.model.beginTime){
          this.beginTime = moment(this.model.beginTime, 'HH:mm:00');
        }
        if(this.model.endTime){
          this.endTime = moment(this.model.endTime, 'HH:mm:00');
        }
        this.handleUserSearch("", this.model);
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
        this.$refs.form.clearValidate();
        this.beginTime = ''
        this.endTime = ''
      },
      /**
       * 查询老师
       * @param val
       * @param name
       */
      handleUserSearch(val, initData){
        getAction("/sys/user/list", {'realname': '*'+val+'*','userIdentity_FindInSet': '6','relTenantIds_FindInSet':Number(Vue.ls.get(TENANT_ID))}).then(res => {
          this.userData = res.result.records
          if(initData.psychologistId){
            this.userData.push({"id": initData.psychologistId, "realname": initData.name})
          }
        })
      },
      /**
       * 选择老师
       * @param value
       */
      handleUserChange(val) {
        this.userData.forEach(item => {
          if(item.id === val){
            this.model.name = item.realname;
          }
        })
      },

      handleOk () {
        const that = this;
        // 触发表单验证
         this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            this.beginTime = this.model.beginTime
            this.endTime = this.model.endTime
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }else{
             return false;
          }
        })
      },
      handleCancel () {
        this.close()
      },
      changeBeginTime(time, timeString){
        this.model.beginTime = timeString
      },
      changeEndTime(time, timeString){
        this.model.endTime = timeString
      }
    }
  }
</script>

<style lang="less" scoped>

</style>